export const TrackPageSection = 'all'
export enum TrackMediaSection {
  Facebook = 'facebook',
  Linkedin = 'linkedin',
  Instagram = 'instagram',
}
export enum TrackPageType {
  Global = 'global_page',
  Home = 'home',
  Games = 'games',
  Support = 'support',
  News = 'news',
  GameDetail = 'game_detail',
  Navbar = 'top_navigation',
  Footer = 'bottom_navigation',
  About = 'about_us',
  PersonalInfo = 'do_not_sell_my_personal',
  PrivacyPolicy = 'privacy_policy',
  TermsService = 'terms_of_service',
  Cookie = 'cookies_setting',
  Blog = 'blog',
}

export enum TrackHomeSection {
  Video = 'video_banner',
  Banner = 'activity_resource_banner',
  News = 'news',
  ViewAll = 'news_view_all',
  Games = 'featured_games',
  GamesGo = 'featured_games_go',
  GamesDetail = 'featured_games_go_type',
  GamesSlide = 'featured_games_slide',
  GamesAll = 'featured_games_allgames',
  Awards = 'awards_honors',
  AwardsSlide = 'awards_honors_slide',
  Ratings = 'important_features',
  Experience = 'player_experiences',
  FAQ = 'faq',
  ContractUs = 'FAQ_contact_us',
}

export enum TrackGamesSection {
  Banner = 'pic_banner',
  Swiper = 'latest_games',
  SwiperItemIcon = 'latest_games_icon',
  SwiperItemStore = 'latest_games_store',
  List = 'all_games',
  Introduce = 'introduce',
}

export enum TrackGameDetailSection {
  Info = 'top_resource',
  Swiper = 'game_page',
  Intro = 'game_introduction',
  Footer = 'bottom_pic',
}

export enum TrackSupportSection {
  All = 'all',
  Banner = 'pic_banner',
  List = 'faq',
  From = 'contact_us_table',
  FromSelectGame = 'contact_us_select',
  FromSelectGameModal = 'contact_us_pop',
  FromChooseGame = 'contact_us_choose',
  FromSubmit = 'contact_us_submit',
}

export enum TrackNewsSection {
  Banner = 'pic_banner',
  BannerSlide = 'pic_banner_slide',
  List = 'news_blog',
  From = 'join_us_letter',
}

export enum TrackAboutSection {
  Intro = 'avia_Introduction',
  Coverage = 'coverage_area',
  Vision = 'value_vision',
  Life = 'life_at_avia',
  Care = 'we_care',
}

export enum TrackPersonalInfoSection {
  Subject = 'request_back_from',
  Submit = 'request_from_button',
}
export enum TrackNavbarSection {
  Logo = 'avia_logo',
  Media = 'social_media_icon',
  Subscribe = 'subscribe_us',
}

export enum TrackFooterSection {
  Media = 'social_media_icon',
}

export enum TrackStoreName {
  Apple = 'App Store',
  Galaxy = 'Galaxy Store',
  Android = 'Android App',
}

export const TrackCookieSection = {
  FixedBanner: 'cookie_banner',
  FixedIcon: 'floating_entrance',
  Setting: 'setting_pop',
  Save: 'setting_pop_save',
}

export const TrackBlogSection = {
  Share: 'share_all',
  QrCode: 'code',
  More: 'more_content',
  Install: 'install',
}
